export const productFragment = `
 product {
      _id
      code
      name
      coverImage
      status
      inventory {
        _id
        quantityOnHand
      }
      inStock
       requiredComputedQuantityOnHand
       hasSubComponents
       productType
    }
`

export const cartFragment = `
      _id
      net
      gross
      shippingFee
      updatedAt
      summary
      taxAmount
      status
      items {
        _id
        ${productFragment}
        quantity
        price
        net
        remarks
        tags
        discount
        originalPrice
        shippingWeight
        serialNumbers {
          _id
          code
        }

      }
      paymentBalance {
        _id
        balance
        totalPaid
      }
`
